import Core from '@/core/module';
import Hammer from 'hammerjs';

export default class Gallery extends Core {
    init() {
        this.index = 0;
        this.nrOfSlides = this.$el.find('.product-slider__thumbs li').length;
        this.$thumbWrapper = this.$el.find('.product-slider__thumbs-wrapper');
        this.$figureWrapper = this.$el.find('.product-slider__figure');

        this.goTo(0);
        this.addEventListeners();
    }

    addEventListeners() {
        var ThumbwrapperHammer = new Hammer(this.$thumbWrapper[0]);
        var FigureHammer = new Hammer(this.$figureWrapper[0]);

        let startX = 0;

        ThumbwrapperHammer.on('panstart panend panmove', (e) => {
            const thumbWrapperWidth = this.$thumbWrapper.width();
            const thumbInnerWidth = this.$thumbWrapper.find('ul')[0].scrollWidth;

            if(e.type == 'panstart') {
                startX = parseInt(this.$thumbWrapper.find('ul').css('left'));
            }

            let newPosition = startX + e.deltaX;

            if(newPosition <= thumbWrapperWidth-thumbInnerWidth) {
                newPosition = thumbWrapperWidth-thumbInnerWidth;
            }

            if(newPosition >= 0) {
                newPosition = 0;
            }

            this.$thumbWrapper.find('ul').css({
                left: newPosition
            })
        });

        FigureHammer.on('swipe', (e) => {
            if(e.direction == 4) {
                this.$el.find('.product-slider__button--left').trigger('click');
            }
            else {
                this.$el.find('.product-slider__button--right').trigger('click');
            }
        });

        this.$el.on('mousedown', '.product-slider__thumbs a, .product-slider__figure a', (e) => {
            e.preventDefault();
        });

        this.$el.on('click', '.product-slider__dot', (e) => {
            e.preventDefault();
            const $el = $(e.currentTarget);

            this.index = $el.index();

            this.goTo();
        })


        this.$el.on('click', '.product-slider__thumbs a', (e) => {
        	e.preventDefault();

        	const $el = $(e.currentTarget);
        	const $container = $el.closest('li');

        	this.index = $container.index();

            this.goTo();
        });

        this.$el.on('click', '.product-slider__figure a', (e) => {
            e.preventDefault();
        })

        this.$el.on('click', '.product-slider__button--right', (e) => {
            e.preventDefault();

            this.index++;

            if(this.index >= this.nrOfSlides-1) {
                this.index = this.nrOfSlides-1;
            }

            this.goTo();
        });

        this.$el.on('click', '.product-slider__button--left', (e) => {
            e.preventDefault();

            this.index--;

            if(this.index < 0) {
                this.index = 0;
            }

            this.goTo();
        });
    }

    goTo() {
        const $newSlide = this.$el.find('.product-slider__thumbs li').eq(this.index);
        const newImage = $newSlide.find('a').attr('href');

        $newSlide.addClass('product-slider__thumb--active').siblings().removeClass('product-slider__thumb--active');
        this.$el.find('[index]').text(this.index + 1);

        this.$el.find('.product-slider__figure img').attr({
            src: newImage
        });

        if(this.index <= 0) {
            this.$el.find('.product-slider__button--left').addClass('product-slider__button--hide');
        }
        else {
            this.$el.find('.product-slider__button--left').removeClass('product-slider__button--hide');
        }

        if(this.index >= this.nrOfSlides-1) {
            this.$el.find('.product-slider__button--right').addClass('product-slider__button--hide');
        }
        else {
            this.$el.find('.product-slider__button--right').removeClass('product-slider__button--hide');
        }

        this.$el.find('.product-slider__dot').eq(this.index).addClass('product-slider__dot--active').siblings().removeClass('product-slider__dot--active');

        this.showIndexCount();
    }

    showIndexCount() {
    	$('.product-slider__count').addClass('product-slider__count--show');

        clearTimeout(this.showIndexCountTimeout);
        this.showIndexCountTimeout = setTimeout(() => {
            $('.product-slider__count').removeClass('product-slider__count--show');
        }, 1000);
    }
}